import {
  BasicButton,
  ButtonGroup,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Stack,
  Text,
} from "@certn/cascadia";
import { Divider, List, ListItem } from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type ReferenceRuleOptionsModalProps = {
  close: () => void;
};

export const ReferenceRuleOptionsModal = ({
  close,
}: ReferenceRuleOptionsModalProps) => {
  const { t } = useTranslation();

  return (
    <>
      <DialogHeader onClose={close}>{t("Reference rule options")}</DialogHeader>
      <DialogContent>
        <Stack gap="space-4">
          <Stack gap="space-4">
            <Text style="global/heading-medium">
              <Trans>What are reference rules</Trans>
            </Text>
            <Text style="global/body-primary" color="text-weak">
              <Trans>
                Reference rules define the requirements a nominated referee must
                meet for this template. These rules affect what information the
                applicant must provide and how the reference is validated.
              </Trans>
            </Text>
          </Stack>
          <Divider />
          <Stack gap="space-4">
            <Text style="global/heading-medium">
              <Trans>Default reference rules</Trans>
            </Text>
            <List type="unordered">
              <ListItem>
                <Text style="global/body-primary" color="text-weak">
                  <Trans>
                    The applicant must nominate a referee who can confirm the
                    gap period.
                  </Trans>
                </Text>
              </ListItem>
              <ListItem>
                <Text style="global/body-primary" color="text-weak">
                  <Trans>
                    The referee’s name and contact details are required.
                  </Trans>
                </Text>
              </ListItem>
              <ListItem>
                <Text style="global/body-primary" color="text-weak">
                  <Trans>
                    There is no minimum relationship length enforced.
                  </Trans>
                </Text>
              </ListItem>
            </List>
            <Text style="global/body-primary" color="text-weak">
              <Trans>
                These settings are suitable for general background screening
                where no specific regulatory framework applies.
              </Trans>
            </Text>
          </Stack>
          <Divider />
          <Stack gap="space-4">
            <Text style="global/heading-medium">
              <Trans>BPSS reference rules</Trans>
            </Text>
            <List type="unordered">
              <ListItem>
                <Text style="global/body-primary" color="text-weak">
                  <Trans>A 3-year lookback period is required.</Trans>
                </Text>
              </ListItem>
              <ListItem>
                <Text style="global/body-primary" color="text-weak">
                  <Trans>Gaps longer than 3 months must be queried</Trans>
                </Text>
              </ListItem>
              <ListItem>
                <Text style="global/body-primary" color="text-weak">
                  <Trans>
                    Referees must have known the applicant for at least 3 years
                  </Trans>
                </Text>
              </ListItem>
              <ListItem>
                <Text style="global/body-primary" color="text-weak">
                  <Trans>Professional contact details are required.</Trans>
                </Text>
              </ListItem>
              <ListItem>
                <Text style="global/body-primary" color="text-weak">
                  <Trans>The referee’s job title must be provided.</Trans>
                </Text>
              </ListItem>
            </List>
            <Text style="global/body-primary" color="text-weak">
              <Trans>
                These settings align with the UK Baseline Personnel Security
                Standard (BPSS) requirements for character references used to
                account for gaps.
              </Trans>
            </Text>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogFooter>
        <ButtonGroup>
          <BasicButton size="medium" onPress={close}>
            <Trans>Close</Trans>
          </BasicButton>
        </ButtonGroup>
      </DialogFooter>
    </>
  );
};
